import React from "react";
import Collapse from 'react-bootstrap/Collapse';

const modelName = "form_rule";

export default class ValidatingRuleSection extends React.Component{

  render(){
    const formRule = this.props.form_rule;
    return (
    <div className="container">
      <div className="form-group row">
        <div className="col-12">
          Use condition to conditionally validate target input
          <Collapse in={this.props.form_rule.use_nocode_condition !== true}>
            <div className="alert alert-danger" role="alert">
              This validating form rule has no condition, meaning the target attribute will always be invalid 
            </div>
          </Collapse>
        </div>
      </div>
      <div className="form-group row">
        <div className="col-12">
          <h4>Validation Rule fields</h4>
          <div className='form-group'>
            <label htmlFor='form_rule[message_content]'>Message for validation:</label>
            <div><i className="fas fa-info-circle"></i> this message will be displayed for target attribute when invalid</div>
            <input
              type='text'
              className='form-control'
              name='form_rule[message_content]'
              data-model-name={modelName}
              data-attribute-name='message_content'
              value={formRule.message_content}
              onChange={this.props.updateAttributeOnEvent} />
          </div>
        </div>
      </div>
    </div>);
  }
}